import React from 'react'
import { useTranslation } from 'react-i18next';

type Props = {
  isProduction?: boolean;
}

const PlaceOfDeliveryMonthConsumptionHeader = ({ isProduction }: Props) => {
  // translations
  const tLabels = useTranslation("placeOfDelivery\\placeOfDelivery").t;

  // helpers
  const getConsumptionTitle = () => { 
    if (isProduction) {
      return tLabels("placeOfDeliveryMonthConsumptionHeader.production");
    } else {
      return tLabels("placeOfDeliveryMonthConsumptionHeader.consumption");
    }
  }

  // render
  return (
    <div className="px-2 px-sm-3 mb-2 text-muted font-weight-bold">
      <div className="row no-gutters align-items-center">
        <div className="col">
          {tLabels("placeOfDeliveryMonthConsumptionHeader.month")}
        </div>
        <div className="col text-center">
          <span>{tLabels("placeOfDeliveryMonthConsumptionHeader.planConsumption")} </span>
          <span className="d-none d-lg-inline">{getConsumptionTitle()} </span>
          <small>[MWh]</small>
        </div>
        <div className="col text-center">
          <span>{tLabels("placeOfDeliveryMonthConsumptionHeader.realConsumption")} </span>
          <span className="d-none d-lg-inline">{getConsumptionTitle()} </span>
          <small>[MWh]</small>
        </div>
      </div>
    </div>
  )
}

export default PlaceOfDeliveryMonthConsumptionHeader;